<script setup lang="ts">
// how to use 
//      <AssociationAutoComplete
//       v-model:select-array="trySelect"
//       />
//      const trySelect= ref([])
// ** must be ref cannot be reactive
//  only return deptNo[]

import { reactify } from "@vueuse/core"
import { onMounted, reactive, watch } from "vue"
definePage({
  meta: {
      action: 'manage',
      subject: 'TCA',
  },
})

interface Props {
    selectArray:[]
}
interface Emit {
//   (e: 'update:isDialogVisible', value: boolean): void
  (e: 'update:selectArray', value: []): void
}

const props = withDefaults(defineProps<Props>(), {
    selectArray:[]
})

const customFilter =(itemTitle, queryText, item)=> {
  const textOne = item.raw.depName.toLowerCase()
  const textTwo = item.raw.depNo.toLowerCase()
  const searchText = queryText.toLowerCase()
  return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
}

const emit = defineEmits<Emit>()

// 👉 協會API
// 
const { data: subDeptsData, execute: fetchSubDept } = await useApi<any>(createUrl('/du/org/class/getSubDept', {
  query: {
    upperDepNo: 'asso' ,
  },
}))
const associations = computed(()=>{
  return subDeptsData.value?subDeptsData.value:[]
  }
)
const select = ref([])

const selectAllAss =() =>{
  let arr = associations.value.map(item => item.depNo)
  select.value = arr
}


watch(select,()=>{
    console.log('select.value',select.value)
    emit('update:selectArray', select.value)
})

onMounted(()=>{
    select.value =props.selectArray
})
</script>
<template>
<div>
    <v-btn @click="selectAllAss" variant="tonal" class="mb-2" size="small">選擇所有協會</v-btn>
            <!-- id: elementId, -->
        <v-autocomplete
          v-bind="{
            ...$attrs,
            class: null,
            label: undefined,
            variant: 'outlined',
            menuProps: { 
              contentClass: ['app-inner-list', 'app-select__content', 'v-select__content', $attrs.multiple !== undefined ? 'v-list-select-multiple' : ''] 
            }
          }"
          :custom-filter="customFilter"
          v-model="select"
          :items="associations"
          color="blue-grey-lighten-2"
          item-title="depName"
          item-value="depNo"
          chips
          label="選擇協會"
          closable-chips
          multiple
          clearable
        >
          <template v-slot:chip="{ props, item }">
            <v-chip
              v-bind="props"
              :text="item.raw.depName"
            ></v-chip>
              <!-- :prepend-avatar="item.raw.avatar" -->
          </template>
          <template v-slot:item="{ props, item }">
            <v-list-item
              v-bind="props"
              :subtitle="item.raw.depNo"
              :title="item.raw.depName"
            ></v-list-item>
              <!-- :prepend-avatar="item.raw.avatar" -->
          </template>
        </v-autocomplete>
</div>
</template>
